<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-main class="pa-0">
      <v-container>
        <v-row no-gutters>
          <v-col cols="12" md="2" class="px-2 mb-5">
            <v-card @click="showAuricularGraphic = true">
              <v-card-title>
                <v-icon color="primary" class="mr-2"></v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'" v-translate>Auricular</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
            <AcupunctureGraphicMode :show="showAuricularGraphic" @close="showAuricularGraphic = false" :auricular="true" :admin="false" :createMode="true" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import AcupunctureGraphicMode from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGraphicMode.vue";

export default {
  name: "AcupunctureAuricular",
  components: {
    Breadcrumbs,
    AcupunctureGraphicMode
  },
  data: () => ({
    showAuricularGraphic: false
  }),
  computed: {
    items() {
      return [
        {
					text: this.$gettext("Dashboard"),
					disabled: true,
					link: true,
          to: { name: "home" }
				},
				{
					text: this.$gettext("Treatments"),
					disabled: false,
					link: true,
					to: { name: "treatments" }
				},
				{
					text: this.$gettext("Auricular Acupuncture"),
					disabled: true,
					link: true
				}
			];
    }
  },
  mounted() {
    this.$store.dispatch("RESET_DATA");
  }
}
</script>